import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-drawer",
  "use": "icon-close-drawer-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 22\" id=\"icon-close-drawer\"><g stroke=\"currentColor\"><path d=\"M3.372 11L7 13.54V8.46L3.372 11z\" /><path stroke-width=\"2\" stroke-linecap=\"square\" d=\"M3 4h18M3 18h18m-11-7h11\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol